import GetStarted from './GetStarted';
import PersonalInformation from './PersonalInformation';
import AccountSetup from './AccountSetup';
import CommunicationPreferences from './CommunicationPreferences';
import ActivationSuccess from './ActivationSuccess';
import { isAvMed } from 'context';
import { useEffect } from 'react';
import { useAdobeAnalytics } from '@sentara-health/platform-analytics';
import { useLocation } from 'react-router-dom';
import { domainForSegment } from 'common';

// Define component array outside of the RegistrationSteps component
const formComponents = isAvMed() ? [
  PersonalInformation,
  AccountSetup,
  CommunicationPreferences,
  ActivationSuccess,
] :
  [
    GetStarted,
    PersonalInformation,
    AccountSetup,
    CommunicationPreferences,
    ActivationSuccess,
  ];

interface RegistrationStepsProps {
  page: number;
  setPage: (page: number) => void;
  formData: any;
  setFormData: (data: any) => void;
  setPlantypes: (types: any) => void;
  plantypes?: string;
  item: any;
  guest: boolean;
  t: (key: string) => string; // Add proper typing for the translation function
  FormTitles: string[];
}

const RegistrationSteps = ({
  page,
  setPage,
  formData,
  setFormData,
  setPlantypes,
  plantypes,
  item,
  guest,
  t,
  FormTitles,
}: RegistrationStepsProps) => {
  let planType: string;
  if (guest) {
    planType = 'guest';
  } else if (isAvMed()) {
    planType = 'individual';
  } else if (plantypes === '') {
    planType = 'guest';
  } else {
    planType = plantypes!;
  }
  return (
    <RegistrationStepsComponent
      page={page}
      setPage={setPage}
      formData={formData}
      setFormData={setFormData}
      setPlantypes={setPlantypes}
      plantypes={planType}
      item={item}
      guest={guest}
      t={t}
      FormTitles={FormTitles}
    />
  );
};

const RegistrationStepsComponent = ({
  page,
  setPage,
  formData,
  setFormData,
  setPlantypes,
  plantypes,
  item,
  guest,
}: RegistrationStepsProps) => {
  const CurrentComponent = formComponents[page];
  const { pageView } = useAdobeAnalytics();
  const { pathname } = useLocation();

  // Define page names for each registration step
  const pageNames = isAvMed() ? [
    'Registration – Step 1: Personal Information',
    'Registration – Step 2: Account Setup',
    'Registration – Step 3: Communication Preferences',
    'Registration – Step 4: Activation Success',
  ] : [
    'Registration – Step 1: Get Started',
    'Registration – Step 2: Personal Information',
    'Registration – Step 3: Account Setup',
    'Registration – Step 4: Communication Preferences',
    'Registration – Step 5: Activation Success',
  ];

  // Fire pageView event when page changes
  useEffect(() => {
    if (pageNames[page]) {
      pageView({
        segment: `${domainForSegment}${pathname}`,
        page: {
          pageName: pageNames[page],
          pageType: 'Registration',
          siteSection: 'registration',
          eventType: 'pageView',
        },
      });
    }
  }, [page]); // Only fire when page number changes

  return (
    <CurrentComponent
      setPage={setPage}
      page={page}
      formData={formData}
      setFormData={setFormData}
      setPlantypes={setPlantypes}
      plantypes={plantypes}
      item={item}
      guest={guest}
    />
  );
};

export default RegistrationSteps;